import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useInitialCountsLoad } from './contract-management.service';
import Page from 'Common/Layout/Page';
import Menu from './Views/MenuView/Menu.view';
import MarkerMeetingsColumns from './Datatables/ColumnDefinitions/MarkerMeetingsColumns';
import ContractFees from './Views/ContractFees/ContractFees.view';
import TeamManagement from './Views/MarkingTeams/TeamManagement.view';
import ContractTemplates from './Views/ContractTemplates/ContractTemplates.view';
import ScriptAllocation from './Views/ScriptAllocation/ScriptAllocation.view';
import ScriptDates from './Views/ScriptDates/ScriptDates.view';
import MarkerMeetings from './Views/MarkerMeetings/MarkerMeetings';

const MarkersContractManagement = ({ grouping }) => {
	document.title = `Contract Management - ${grouping}s Menu`

    const [activeScreen, setActiveScreen] = useState('');
    const { isLoading } = useInitialCountsLoad();
    const qualification_year = useSelector(state => state.contract_globals.qualification_year.selected);
    const handleActiveModal = (menuName = '') => setActiveScreen(menuName);

	switch (activeScreen) {
		case 'templates':
			return <ContractTemplates handleActiveModal={handleActiveModal} appointeeType={grouping} />;
		case 'fees':
			return <ContractFees handleActiveModal={handleActiveModal} />;
		case 'teams':			
			return <TeamManagement handleActiveModal={handleActiveModal} appointeeType={grouping} />;
		case 'script_allocation':
			return <ScriptAllocation handleActiveModal={handleActiveModal} />;
		case 'script_dates':
			return <ScriptDates handleActiveModal={handleActiveModal} appointeeType={grouping} />;
		case 'marker_meetings':
			return (
				<MarkerMeetings
					show={true}
					handleClose={handleActiveModal}
					title="Marker Meetings"
					contractTypes={['MAR', 'CMK']}
					year={qualification_year}
					keyField="appointmentId"
					screenType="MM"
					columns={MarkerMeetingsColumns()}
				/>
			);
		default:
			return (
				<>
					<Page title={`${grouping}s`}>
					</Page>
					<Menu isLoading={isLoading} handleActiveModal={handleActiveModal} />
				</>
			);
	}
};

export default MarkersContractManagement;
